import { fr as FR } from './_fr';
import { en as EN } from './_en';
import { de as DE } from './_de';

export const locales = {
    FR,
    EN,
    DE,
};
